<template>
  <div class="Inclass" :style="{ height: height + 'px' }">
    <div class="small">
      <div class="arrow">
        <div @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</div>
        <div class="txt">{{currentPage}} / {{pageCount}}</div>
        <div @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</div>
<!--        <div @click="screen" class="screen">全屏展示</div>-->
      </div>
      <pdf :src="url" class="pdf" :page="currentPage" @num-pages="pageCount=$event"
           @page-loaded="currentPage=$event" @loaded="loadPdfHandler">
      </pdf>
    </div>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'

  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      },
      url: {
        type: String
      }
    },
    components: {
      pdf
    },
    data () {
      return {
        currentPage: 1, // pdf文件页码
        pageCount: 0 // pdf文件总页数
      }
    },
    methods: {
      changePdfPage (val) { // 判断页数
        if (val === 0 && this.currentPage > 1) {
          this.currentPage--
        }
        if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
        }
      },
      // pdf加载时
      loadPdfHandler (e) {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      screen () {
        window.open(this.url)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .Inclass {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    .class {
      width: 100%;
    }

    .small {
      padding-top: 50px;
      overflow: hidden;
      position: relative;
    }

    .arrow {
      position: absolute;
      left: 50%;
      top: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      width: 260px;
      margin: 0 0 0 -130px;

      .turn {
        width: 50px;
        cursor: pointer;
        display: inline-block;
      }

      .txt {
        width: 50px;
        display: inline-block;
      }

      .screen {
        width: 60px;
        cursor: pointer;
        display: inline-block;
      }

    }

    .pdf {
      width: 80%;
      max-width: 1200px;
      margin: 0 auto;
      left: 10%;
    }

    .big {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 99;
      background-color: rgba(255, 255, 255, 0.5);
      overflow-x: hidden;
      overflow-y: auto;
      padding-top: 50px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/Inclass/Inclass.vue